const styles = theme => ({
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    gridHeader: {
        marginBottom: theme.spacing(0.7)
    },
    groupHeader: {
        marginBottom: theme.spacing(1)
    }
});

export default styles;